module.exports = __webpack_public_path__ + "img/rsz_terasa-min.2987c0f7.png";